import React from 'react'
import { useTranslation } from 'react-i18next'

import Field from '../../../../components/Form/Field'
import FieldLabelWrapper from '../../../../features/components/Form/FieldLabelWrapper'

import { AD_SERVER_TYPE, adServersList, API_KEY } from './reusableFields'

import useCommonStyles from '../../../../styles/common/listPage'

function AdServerFormFields({ formik }) {
  const { t } = useTranslation()

  const commonClasses = useCommonStyles()

  return (
    <div className={commonClasses.formRow}>
      <FieldLabelWrapper label={t('Ad Server Name')} labelFor={AD_SERVER_TYPE}>
        <Field
          formik={formik}
          id={AD_SERVER_TYPE}
          name={AD_SERVER_TYPE}
          options={adServersList}
          placeholder={t('Ad Server Name')}
        />
      </FieldLabelWrapper>
      <FieldLabelWrapper label={t('API key')} labelFor={API_KEY}>
        <Field formik={formik} id={API_KEY} name={API_KEY} placeholder={t('API key')} enableReinitialize />
      </FieldLabelWrapper>
    </div>
  )
}

export default AdServerFormFields
